import React from "react";

import { s360ConfigService } from "../Services/S360Config";

function PopUpMessage(props) {
  return (
    <div className="s360-chat-full-screen-container">
      <div className="s360-chat-transcript-email-form-container">
        <div
          className="s360-pop-up-message-close-icon"
          onClick={props.onClose}
          style={{ cursor: "pointer" }}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="18"
            height="18"
            viewBox="0 0 24.674 24.668"
          >
            <defs></defs>
            <path
              fill="black"
              style={s360ConfigService.config?.customDesign?.popupMessageCloseIcon}
              d="M26.546,23.623l8.813-8.813a2.065,2.065,0,0,0-2.92-2.92L23.625,20.7,14.813,11.89a2.065,2.065,0,1,0-2.92,2.92l8.813,8.813-8.813,8.813a2.065,2.065,0,1,0,2.92,2.92l8.813-8.813,8.813,8.813a2.065,2.065,0,1,0,2.92-2.92Z"
              transform="translate(-11.285 -11.289)"
            />
          </svg>
        </div>
        <div className="s360-pop-up-message-label" style={s360ConfigService.config?.customDesign?.popupMessageLabel}>
          {props.popUpMessage || ""}
        </div>
      </div>
    </div>
  );
}

export default PopUpMessage;
